/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import SDPageHeader from "../SDPageHeader";
import { sdCreateRequest, sdMakeRequests, sdRequestsCompleted, sdRenderLoadingOrError, sdGetSelectedProjectId, sdSetSelectedProjectId, sdUTCTimestampToFriendlyDateAndTimeAgo } from "helpers/sdHelper";
import { sdGetProjects, sdGetActivitiesForProject, sdGetMe } from "services/service-desk/sdService";
import { Card } from "react-bootstrap";
import Flex from "components/common/Flex";
import Avatar from "components/common/Avatar";
import { Link } from "react-router-dom";
import SDUserBadge from "../SDUserBadge";

const SDActivity = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [me, setMe] = useState(null);
    const [projects, setProjects] = useState([]);
    const [selectedProjectId, setSelectedProjectId] = useState(sdGetSelectedProjectId());
    const [activities, setActivities] = useState([]);

    useEffect(() => {
        let allRequests = [
            sdCreateRequest(() => sdGetProjects(), setProjects),
            sdCreateRequest(() => sdGetMe(), setMe),
            sdCreateRequest(() => sdGetActivitiesForProject(selectedProjectId), setActivities)
        ];

        sdMakeRequests(allRequests, setLoading, setError);
    }, []);

    useEffect(() => {
        reloadActivities();
    }, [selectedProjectId]);

    const reloadActivities = () => {
        sdGetActivitiesForProject(selectedProjectId).then(res => {
            setActivities(res.data);
        }).catch(err => {
            setActivities([]);
            console.error(err)
        });
    }

    if (!sdRequestsCompleted(loading, error)) {
        return sdRenderLoadingOrError(loading, error);
    }

    return (
        <>
            <SDPageHeader title="Activity" me={me} projects={projects} selectedProjectId={selectedProjectId} onProjectChanged={(id) => { setSelectedProjectId(id); sdSetSelectedProjectId(id); }} showCreateIssue></SDPageHeader>

            <Card >
                <Card.Body className="p-3">
                    {activities && activities.length > 0 ? <>
                        {activities.map((activity, index) => (<SDActivityItem key={activity.id} activity={activity}></SDActivityItem>
                        ))}
                    </> : <><i>No activity to display for this project.</i></>}
                </Card.Body>
            </Card>
        </>
    )
}

const SDActivityItem = ({ activity }) => {
    let avatar = <Avatar emoji="⚙️"></Avatar>
    let name = "System"
    if (activity.changedByUser) {
        avatar = <Avatar name={activity.changedByUser.displayName}></Avatar>
        name = activity.changedByUser.displayName;
    }

    const getMessage = () => {
        let res = activity.message;

        if (activity.entityType === "Issue" && activity.issue) {
            let issueLink = <Link to={`/service-desk/issue/${activity.issue.id}`}>({activity.issue.key}) {activity.issue.subject}</Link>
            if (activity.message.includes("Created issue from email message")) {
                res = <span>Created issue {issueLink}</span>
            } else {
                res = <span>{activity.message} on issue {issueLink}</span>
            }
        }
        return res;
    }
    
    return (
        <Flex className="mt-3">

            {avatar}
            <div className="flex-1 ms-2 fs--1">
                <a href="#?" className="fw-semi-bold">
                    {name}
                </a>
                <SDUserBadge user={activity.changedByUser}></SDUserBadge>

                <p className="mb-1 bg-200 rounded-3 p-2">{getMessage()}
                </p>

                <div className="px-2">
                    {sdUTCTimestampToFriendlyDateAndTimeAgo(activity.timestamp)}
                </div>
            </div>
        </Flex>
    )
}

export default SDActivity;